import { useState } from "react";
import {
  Area,
  AreaChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { ChartSkeleton, SectionCard } from "@/shared/components";
import { cn } from "@/shared/lib/utils";
import { useWeeklyTrend } from "./hooks";

const METRICS = ["키워드", "채널", "콘텐츠"] as const;

export function WeeklyTrend() {
  const { data, isLoading } = useWeeklyTrend();
  const [metric, setMetric] = useState<(typeof METRICS)[number]>("키워드");

  return (
    <SectionCard>
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div>
          <h3 className="text-[14px] font-semibold">주간 성장 추이</h3>
          <p className="text-[12px] text-text-tertiary">
            최근 6주간 핵심 지표 변화
          </p>
        </div>
        <div className="flex gap-1 rounded-sm bg-surface-sunken p-1">
          {METRICS.map((m) => (
            <button
              key={m}
              onClick={() => setMetric(m)}
              className={cn(
                "rounded-md px-3 py-1 text-[11px] font-medium transition-colors",
                metric === m
                  ? "bg-surface-raised shadow-none"
                  : "text-text-tertiary hover:text-text-primary",
              )}
            >
              {m}
            </button>
          ))}
        </div>
      </div>
      <div className="mt-4">
        {isLoading ? (
          <ChartSkeleton height={260} />
        ) : (
          <ResponsiveContainer width="100%" height={260}>
            <AreaChart data={data ?? []}>
              <CartesianGrid strokeDasharray="3 3" className="stroke-border" />
              <XAxis dataKey="week" tick={{ fontSize: 11 }} />
              <YAxis tick={{ fontSize: 11 }} />
              <Tooltip />
              <Area
                type="monotone"
                dataKey={metric}
                stroke="hsl(182, 80%, 26%)"
                fill="rgba(13,115,119,0.12)"
                strokeWidth={2}
              />
            </AreaChart>
          </ResponsiveContainer>
        )}
      </div>
    </SectionCard>
  );
}
